import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import config from '../config'
const base_url = config.apiUrl

const model = 'UnitProducts/'

export const unitProductsService = {
  getAll,
  getAllPaginate,
  getAllByCategoryType,
  getAllByCategoryAndBrand,
  getAllByCategoryAndBrandAndWarehouse,
  getById,
  add,
  edit,
  delete: _delete,
  getImages,
  importFromExcel,

  search
}

function getAll() {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllPaginate(dto) {
  const url = base_url + model + 'getAllPaginate'
  console.log(url)

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getAllByCategoryType(categoryType) {
  const url = base_url + model + 'getAllByCategoryType/' + categoryType
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllByCategoryAndBrand(categoryId, brandId) {
  const url =
    base_url + model + 'getAllByCategoryAndBrand/' + categoryId + '/' + brandId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllByCategoryAndBrandAndWarehouse(
  categoryId,
  brandId,
  warehouseId
) {
  const url =
    base_url +
    model +
    'getAllByCategoryAndBrandAndWarehouse/' +
    categoryId +
    '/' +
    brandId +
    '/' +
    warehouseId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getById(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(form) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, form, { headers: authHeaderJson() })
}

function edit(id, form) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, form, { headers: authHeaderJson() })
}

function _delete(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}

function getImages(id) {
  const url = base_url + model + 'getImages/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function importFromExcel(dto) {
  const url = base_url + model + 'importFromExcel'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function search(dto) {
  const url = base_url + model + 'search'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}
